import { render } from "./SignUpComponent.vue?vue&type=template&id=4e1b7424&scoped=true"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"

import "./SignUpComponent.vue?vue&type=style&index=0&id=4e1b7424&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1b7424"]])

export default __exports__